<template>
  <div ref="app" id="app">
      <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss">
@import './assets/styles/vw.scss';
@import './assets/styles/function.scss';
#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue